import {inject} from 'aurelia-framework';
import {AuthService} from '../auth/auth-service';
import {Router} from 'aurelia-router';
import {OAuthClient} from "../api/oauth-client";
import {UserClient} from "../api/user-client";
import {AureliaConfiguration} from "aurelia-configuration";
import Client from "../api/client";
import * as _ from 'lodash';

@inject(
    AuthService,
    Router,
    OAuthClient,
    Client,
    UserClient,
    AureliaConfiguration
)
export class Login {

    image = require('./sio-logo-full.svg');
    defaultImage = require('./tobias-reich-jolBvWtbQrE-unsplash.jpg');

    date = new Date();

    configuration = {
        submitBtnClass: 'tw-btn-primary tw-w-full tw-mt-4 tw-text-center',
        actionContainerClass: ' ',
        labels: {
            success: 'user.login_success',
            communicationError: 'user.error_login',
            submit: 'login.login',
        },
        fields: [
            {
                type: 'input',
                label: 'login.username',
                property: 'login',
                required: true,
                constraints: true,
                autocomplete: 'on',
            },
            {
                type: 'input',
                subType: 'password',
                label: 'login.password',
                property: 'password',
                required: true,
                autocomplete: 'on',
            }
        ]
    };

    twoFactorConfiguration = {
        submitBtnClass: 'tw-btn-primary tw-w-full tw-mt-4 tw-text-center',
        actionContainerClass: ' ',
        labels: {
            success: 'user.login_success',
            communicationError: 'user.error_login',
            submit: 'login.verifyDevice',
        },
        fields: [
            {
                type: 'input',
                subType: 'number',
                label: 'login.twoFactorCode',
                property: 'twoFactorToken',
                required: true,
                constraints: true,
            },
            {
                type: 'checkbox',
                checkboxLabel: 'login.trustedDevice',
                property: 'trustDevice',
                default: false,
            },
        ]
    };

    oauthProviders = [];

    deviceIdentifier = null;
    loginData = null;
    twoFactor = false;

    loaded = false;

    constructor(
        authService,
        router,
        oauthClient,
        client,
        userClient,
        appConfig
    ) {
        this.authService = authService;
        this.router = router;
        this.oauthClient = oauthClient;
        this.client = client;
        this.userClient = userClient;

        this.apiUrl = appConfig.get('apiUrl');
    }

    async bind()
    {
        this.deviceIdentifier = localStorage.getItem('deviceIdentifier');

        let data = await this.client.get('oauth2/active-providers', 3600, {credentials: 'omit'});

        this.oauthProviders = data.providers ?? [];
        this.disablePasswordLogin = data.disablePasswordLogin ?? false;
        this.backgroundImage = data.backgroundImage?.replace("$width", "1500")?.replace("$height", "-") ?? this.defaultImage;

        this.announcement = _.sample(data.announcements ?? []);
    }

    unbind()
    {
        this.twoFactor = false;
        this.loginData = null;
    }

    toReset()
    {
        //Note: router does not work here because of some router magic we do with setRoot()
        window.location.href = '/login/request-reset';
    }

    _updateDeviceIdentifier(deviceIdentifier)
    {
        this.deviceIdentifier = deviceIdentifier;
        localStorage.setItem('deviceIdentifier', deviceIdentifier);
    }

    async submit(object)
    {
        let response = await this.oauthClient.getToken(
            object.login,
            object.password,
            this.deviceIdentifier
        );

        if (response.deviceIdentifier) {
            this._updateDeviceIdentifier(response.deviceIdentifier);
        }

        if (response.error === 'verify_two_factor') {
            this.twoFactorConfiguration.fields[1].checkboxLabel = response.trustedDeviceForceReloginInDays;
            this.twoFactor = true;
            this.twoFactorMethod = response.twoFactorMethod;
            this.loginData = object;

            return;
        }

        console.log('RESPONSE', response);

        await this.userClient.load();

        this.authService.login(response);
    }

    async twoFactorVerify(object)
    {
        if (object.twoFactorToken == null || object.twoFactorToken == '') {
            return;
        }

        let response = await this.oauthClient.getToken(
            this.loginData.login,
            this.loginData.password,
            this.deviceIdentifier,
            object.twoFactorToken,
            object.trustDevice
        );

        if (response.deviceIdentifier) {
            this._updateDeviceIdentifier(response.deviceIdentifier);
        }

        await this.userClient.load();

        this.authService.login(response);
    }

    backToFirstStep()
    {
        this.twoFactor = false;
        this.loginData = null;
    }

    loginWithService(service)
    {
        window.location.href = this.apiUrl + 'oauth2/login-with-service/' + encodeURIComponent(service) +
            '?redirect=' + encodeURIComponent(window.location.href) + '&deviceIdentifier=' + encodeURIComponent(this.deviceIdentifier) + '&loginVersion=2';
    }
}
